import VisibilityIcon from '@mui/icons-material/Visibility';
import { IconButton } from '@mui/material';
import { ICommonButtonProps } from '../../../types/button';

export const ViewButton = ({ onClick }: ICommonButtonProps) => {
  return (
    <IconButton
      onClick={() => {
        onClick();
      }}
    >
      <VisibilityIcon fontSize="small" />
    </IconButton>
  );
};
